export default __webpack_public_path__ + "static/Titletown-f0141f7ae850ad80634c8bc64128d412.png";